export default class UnicodeUtils {

    constructor() {
    }

    toBinary(value: string): string {
      const codeUnits = new Uint16Array(value.length);
      for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = value.charCodeAt(i);
      }
      const charCodes = new Uint8Array(codeUnits.buffer);
      let result = '';
      for (let i = 0; i < charCodes.byteLength; i++) {
        result += String.fromCharCode(charCodes[i]);
      }
      return result;
    }

    fromBinary(binary: string): string {
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      const charCodes = new Uint16Array(bytes.buffer);
      let result = '';
      for (let i = 0; i < charCodes.length; i++) {
        result += String.fromCharCode(charCodes[i]);
      }
      return result;
    }

    toBase64(input: string): string {
      const bytes = new TextEncoder().encode(input);
      return btoa(String.fromCharCode(...bytes));
    }
    
    fromBase64(base64: string): string {
      const binaryString = atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
      }
      return new TextDecoder().decode(bytes);
    }
  
}